/**
 * Analytics route tracking component.
 * Replaces the v5 `customHistory.listen()` pattern with v6 useLocation.
 *
 * In v5, we used: customHistory.listen((location, action) => { ... })
 * In v6, we use a component placed inside the Router tree that watches location changes.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from './analytics';
import { cioPage } from '../common/Customer.io';
import { actionsList } from '../Components/Home/Body/MyActions/MyActionLogic';
import { type ERouteOption, categoryName } from '../Interface/Dashboard/CategoryInterface';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const [navigation, detail] = location.pathname.split('/').slice(1);

    // Notifie Customer.io de la nouvelle route pour l'évaluation des Page Rules In-App
    cioPage(location.pathname);

    analytics.trackVu({
      categorie: `${navigation ? categoryName[navigation as ERouteOption] : ''}`,
      titre:
        detail && actionsList.find((a: any) => a.action === detail)
          ? actionsList.find((a: any) => a.action === detail)!.title
          : '',
    });
  }, [location]);

  return null;
};

export default RouteTracker;
